import { DebugContext } from './debug-context'

export const DebugProvider = DebugContext.Provider
